import styled, { css } from 'styled-components';

export const Card = styled.div(
  ({ theme }) => css`
    background-color: ${theme.co.success99};
    border: ${theme.bo.mediumWidth} solid ${theme.co.success50};
    border-radius: ${theme.bo.mediumLarge};
    padding: ${theme.sz.s4};
    position: relative;
    width: 100%;
    overflow: hidden;
    display: flex;
    align-items: stretch;

    svg {
      position: absolute;
      right: ${theme.sz.s4};
      width: 70%;
      color: ${theme.co.success40};
      opacity: 0.3;
    }
  `,
);

export const Content = styled.div(
  () => css`
    display: flex;
    flex-direction: column;
    flex: 1;
    z-index: 1;
    align-items: flex-start;
    min-height: 200px;
  `,
);

export const TextContent = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.sz.s3};
    flex: 1;
  `,
);

export const Title = styled.div(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.xxs};
    color: ${theme.co.neutral10};
  `,
);

export const Description = styled.div(
  ({ theme }) => css`
    ${theme.typography.paragraph.m};
    color: ${theme.co.neutral20};
  `,
);

export const Decoration = styled.div(
  ({ theme }) => css`
    min-width: ${theme.sz.s16};
    text-align: -webkit-right;
  `,
);

export const Image = styled.img(
  ({ theme }) => css`
    position: relative;

    width: ${theme.sz.s12};

    @media (max-width: ${theme.sz.m}) {
      width: ${theme.sz.s8};
    }
  `,
);
